<template>
  <div class="loading" v-if="inProgress">
    <div class="row">
      <div class="text-center w-100">
            <table style="height: 100vh;" class="w-100">
                <tbody>
                    <tr>
                        <td class="align-middle w-100">
                            <img src="/static/images/loading.gif" class="img-fluid"/>
                        </td>
                    </tr>
                </tbody>
            </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {mapState} from 'vuex'
import {mapActions} from 'vuex'
export default {
    name: 'loading',
    props:['inProgress'],
    data () {
        return {
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.loading{
    position: fixed;
    background-color:#66D0FF50;
    z-index: 99999;
    width: 100%;
    height: 100%;
    top: 0;
}
</style>
